var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5001C10.2761 10.5001 10.5 10.2762 10.5 10.0001C10.5 9.72395 10.2761 9.50009 10 9.50009C9.72386 9.50009 9.5 9.72395 9.5 10.0001C9.5 10.2762 9.72386 10.5001 10 10.5001Z",
    stroke: "#101828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.00009C10.2761 4.00009 10.5 3.77623 10.5 3.50009C10.5 3.22395 10.2761 3.00009 10 3.00009C9.72386 3.00009 9.5 3.22395 9.5 3.50009C9.5 3.77623 9.72386 4.00009 10 4.00009Z",
    stroke: "#101828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.0001C10.2761 17.0001 10.5 16.7762 10.5 16.5001C10.5 16.2239 10.2761 16.0001 10 16.0001C9.72386 16.0001 9.5 16.2239 9.5 16.5001C9.5 16.7762 9.72386 17.0001 10 17.0001Z",
    stroke: "#101828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/more-vertical.2745cac647ef9392612454b9ebddbf00.svg";
export { ForwardRef as ReactComponent };